import { createStyles } from 'antd-style'

import { CategoryDropdown } from './Dropdown'
import { NavbarMenu } from './Menu'

const useStyles = createStyles(({ token, prefixCls }) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    gap: token.marginXL
  }
}))

export const LayoutNavbar = () => {
  const { styles } = useStyles()

  return (
    <div className={styles.container}>
      <CategoryDropdown />
      <NavbarMenu />
    </div>
  )
}
